export default __webpack_public_path__ + "6a8c71dccd5a4b1444446684925cf172.jpg";